import { useQueryEmployeeTaxFormsInstanceStatuses } from "../../../query/employeeTaxForms/queries/useQueryEmployeeTaxFormsInstanceStatuses";
import { selectorChecklistViewFromItems } from "../selectors/selectorChecklistViewFromItems";
import { selectorFormChecklistItemFromInstanceStatus } from "../selectors/selectorFormChecklistItemFromInstanceStatus";

/**
 * Same output shape as useEmployeeTaxFormsChecklistView, sourced from ids the
 * requirement's own data-source refresh already resolved (dataSourceMetadata.formIds,
 * see getEmployeeTaxFormsFormIds) — each id is then re-fetched individually with
 * `?expand=BlockedByIds` for real status/blocking, since that isn't reliably
 * available in bulk.
 */
export const useEmployeeTaxFormsChecklistViewByFormIds = (
  formIds: string[]
) => {
  const instanceStatusQueries =
    useQueryEmployeeTaxFormsInstanceStatuses(formIds);

  const isLoading = instanceStatusQueries.some(query => query.isLoading);

  const statuses = instanceStatusQueries
    .map(query => query.data)
    .filter((status): status is NonNullable<typeof status> => !!status);

  const { orderedItems, allCompleted, completedCount } =
    selectorChecklistViewFromItems(
      statuses.map(selectorFormChecklistItemFromInstanceStatus)
    );

  return { isLoading, orderedItems, allCompleted, completedCount };
};
